export default "__VITE_ASSET__C99$pfYp__"